import { ThemeProvider, createTheme } from "@mui/material";

let theme = createTheme({
  palette: {
    primary: {
      main: "#3661EB",
    },
    info: {
      main: "#03C3EC",
    },
    error: {
      main: "#FF3E1D",
    },
    warning: {
      main: "#FFAB00",
      contrastText: "#fff"
    },
    success: {
      main: "#34B97A",
      contrastText: "#fff"
    },
    secondary: {
      main: "#05CD99",
    },
  },
});

const DemoSiteTheme = ({ children }: any) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

// Export theme as CSS variables
export function createCssVarsFromTheme() {
  const root = document.documentElement;
  
  // Colors
  Object.entries(theme.palette).forEach(([key, value]) => {
    if (typeof value === 'object') {
      Object.entries(value).forEach(([subKey, color]: any) => {
        root.style.setProperty(`--mui-${key}-${subKey}`, color);
      });
    } else if (typeof value === 'string') {
      root.style.setProperty(`--mui-${key}`, value);
    }
  });
  
  // Typography
  // Object.entries(theme.typography).forEach(([key, value]) => {
  //   if (typeof value === 'object') {
  //     Object.entries(value).forEach(([subKey, typoProp]: any) => {
  //       root.style.setProperty(`--mui-typography-${key}-${subKey}`, typoProp);
  //     });
  //   } else if (typeof value !== 'function') {
  //     root.style.setProperty(`--mui-typography-${key}`, value);
  //   }
  // });
  
  // // Spacing
  // Array.from({ length: 10 }).forEach((_, i) => {
  //   root.style.setProperty(`--mui-spacing-${i}`, `${theme.spacing(i)}`);
  // });
}
export default DemoSiteTheme;
